import { Team } from "../../../../types/form";

const DEFAULT_TEAM_COLOR = [{ value: "#4B5563", name: "default" }];

export const ensureTeamColor = (team: Team): Team => ({
  ...team,
  color: team.color?.length ? team.color : DEFAULT_TEAM_COLOR,
});
